import { Box } from "@mui/material";

export const SignInHero = (): React.ReactNode => {
  return (
    <Box
      sx={{
        color: "white",
        height: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        fontSize: 24,
        backgroundImage: "url(/images/login_hero.png)",
        backgroundSize: "contain", // fills the box while preserving ratio
        backgroundPosition: "right", // centers the image
        backgroundRepeat: "no-repeat",
      }}
    />
  );
};
